import React, { useState } from "react";
import MyOneBookingModal from "./Modals/MyOneBookingModal";

export default function SmallCalender({
  stringDate,
  bookingDate1,
  bookingDate2,
  bookingDate3,
  bookingDate4,
  bookingDate5,
  bookingDate6,
  bookingDate7,
  bookingDate8,
  bookingDate9,
  bookingDate10,
  bookingDate11,
  bookingDate12,
  bookingDate13,
  bookingDate14,
  bookingDate15,
  bookingDate16,
  bookingDate17,
  bookingDate18,
  bookingDate19,
  bookingDate20,
  bookingDate21,
  bookingDate22,
  bookingDate23,
  bookingDate24,
  bookingDate25,
  bookingDate26,
  bookingDate27,
  bookingDate28,
  bookingDate29,
  bookingDate30,
  bookingDate31,
}) {
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bookingModal, setBookingModal] = useState(false);
  const cancelModal = () => {
    setBookingModal(false);
  };

  return (
    <div>
      {bookingDate1.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">1st {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate1.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate2.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">2nd {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate2.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate3.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">3rd {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate3.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate4.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-tex">4th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate4.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate5.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">5th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate5.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate6.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">6th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate6.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate7.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">7th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate7.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate8.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">8th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate8.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate9.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">9th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate9.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate10.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">10th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate10.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate11.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">11th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate11.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate12.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">12th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate12.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate13.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">13th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate13.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate14.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">14th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate14.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate15.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">15th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate15.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate16.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">16th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate16.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate17.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">17th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate17.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate18.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20  red-text">18th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate18.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate19.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">19th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate19.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate20.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">20th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate20.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate21.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">21st {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate21.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate22.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">22nd {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate22.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate23.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">23rd {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate23.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate24.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">24th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate24.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate25.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">25th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate25.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate26.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">26th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate26.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate27.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">27th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate27.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate28.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">28th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate28.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate29.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">29th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate29.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate30.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">30th {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate30.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {bookingDate31.length > 0 && (
        <div className="bg-white  rounded shadow mt-3">
          <div className="booking-class-content text-center">
            <p className="fontSize20 red-text">31st {stringDate}</p>
            <table className="custom-table">
              <thead className="blueBanner">
                <th>Profile</th>
                <th>Club</th>
                <th>Class</th>
                <th className="hideAt500">Time</th>
              </thead>
              <tbody>
                {bookingDate31.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      setSelectedBooking(item);
                      setBookingModal(true);
                    }}
                  >
                    <td className="fw-bold">
                      {item.viewBookingProfile.username}
                    </td>
                    <td className="fw-bold">{item.viewClubs.name}</td>
                    <td>
                      <p className="fw-bold m-0">{item.viewEvent.name}</p>
                      <p className="showAt500 text-muted m-0">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                    <td className="hideAt500">
                      <p className="text-muted">
                        {item.viewEvent.timeIn} - {item.viewEvent.timeOut}{" "}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {bookingModal && (
        <MyOneBookingModal
          cancelModal={cancelModal}
          selectedBooking={selectedBooking}
        />
      )}
    </div>
  );
}
